import UserSchedule from './UserSchedule.vue'

export default UserSchedule
